import React from 'react'

export default function Footer(){
  return(
    <footer>
    <div class="social-icons">
       
    <a href="https://github.com/KaifArslan">
      <i class="fab fa-github"></i>
    </a>
    <a id='profile-link' target='_blank' href="mailto:kaifarslan1@gmail.com">
      <i class="fa fa-envelope"></i>
    </a>
    <a id='profile-link' target='_blank' href="https://twitter.com/Kaif_Arslan">
      <i class="fab fa-twitter"></i>
    </a>
    
    <a id='profile-link' target='_blank' href="https://www.linkedin.com/in/kaif-arslan-148a86264?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BEICrZmkFQHyp8igVGWe7Yg%3D%3D">
      <i class="fab fa-linkedin-in"></i>
    </a>  
  </div>
  <hr />
  <p>Made with 🤍 by  Kaif Arslan</p>
  <p>2023</p>
  </footer>

  )
}